import { app } from '@root/config';
import axios from 'axios';

const transitUrl = `${app.apiNewService}`;

axios.interceptors.request.use(
  (config) => {
    const requestUrl = config.url;

    if (requestUrl.includes(transitUrl)) {
      return config;
    }

    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const responseUrl = error.config.url;

    if (responseUrl.includes(transitUrl)) {
      return Promise.reject(error);
    }

    // Не перехватываем 401 для проверки 2FA кода
    if (responseUrl.includes('/2fa/check')) {
      return Promise.reject(error);
    }
    if (error.response?.data?.message === 'Invalid credentials.') {
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401) {
      if (
        error.response.data &&
        error.response.data.error === 'access_denied' &&
        error.response.data.two_factor_complete === false
      ) {
        window.location.replace('/authentication/two-factor');
        return Promise.reject(error);
      }
      localStorage.removeItem('accessToken');
      localStorage.removeItem('accessId');
      window.location.replace('/');
    }
    return Promise.reject(error);
  }
);

export default axios;
